export default __webpack_public_path__ + "static/media/shape4.c8332331.png";